/**
 * 全站路由配置
 * 代码中路由统一使用name属性跳转(不使用path属性)
 */

import Vue from 'vue'
import Router from 'vue-router'
import http from '@/utils/httpRequest'
import { isURL } from '@/utils/validate'

Vue.use(Router)

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/404', component: _import('common/404'), name: '404', meta: { title: '404未找到' } },
  { path: '/login', component: _import('common/login'), name: 'login', meta: { title: '登录' } },
  { path: '/reset', component: _import('common/reset'), name: 'reset', meta: { title: '重置密码' } },
  { path: '/protocol', component: _import('common/protocol'), name: 'protocol', meta: { title: '平台协议' } },
]

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: '/',
  component: _import('main'),
  name: 'main',
  redirect: { name: 'login' },
  meta: { title: '主入口整体布局' },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    { path: '/home', component: _import('common/home'), name: 'home', meta: { title: '首页' } },
    { path: '/theme', component: _import('common/theme'), name: 'theme', meta: { title: '主题' } },
    // { path: '/personInfo', component: _import('modules/person/personInfo'), name: 'personInfo', meta: { title: '个人中心' } },
    {
      path: '/welcome',
      component: _import('modules/welcome/Welcome'),
      name: 'welcome',
      meta: { title: '数字弘源' }
    }

  ],
  beforeEnter: function (to, from, next) {
    const token = Vue.cookie.get('token')
    if (!token || !/\S/.test(token)) {
      next({ name: 'login' })
    }
    next()
  }
}

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes.concat(mainRoutes)
})

router.beforeEach((to, from, next) => {
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to) === 'global') {
    const routeList = []
    routeList.push({ title: to.meta.title, parentId: to.meta.parentId, menuId: to.meta.menuId }) // 面包屑页面文字提示title
    to.meta.routeList = routeList
    next()
  } else {
    http({
      url: http.adornUrl('/admin/menu'),
      method: 'get',
      headers:
      {
        Authorization: 'Bearer' + ' ' + Vue.cookie.get('token')
      }
    }).then((res) => {
      if (res.status === 200) {
        fnAddDynamicMenuRoutes(res.data.data)
        router.options.isAddDynamicMenuRoutes = true
        sessionStorage.setItem('menuList', JSON.stringify(res.data.data || '[]'))
        next({ ...to, replace: true })
      } else {
        sessionStorage.setItem('menuList', '[]')
        next({ name: 'login', replace: true })
      }
    })
  }
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload()
    // router.replace(router.history.pending.fullPath);
  }
})

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route) {
  for (let i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children) {
      for (let j = 0; j < globalRoutes[i].children.length; j++) {
        if (route.path === (globalRoutes[i].path + '/' + globalRoutes[i].children[j].path)) {
          return 'global'
        }
      }
    }
  }
  return 'main'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  let temp = []
  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1 && menuList[i].type !== 0) {
      temp = temp.concat(menuList[i].children)
    } else if (menuList[i].children && menuList[i].children.length >= 1 && menuList[i].type === 0) {
      temp = temp.concat(menuList[i].children)
      menuList[i].path = menuList[i].path.replace(/^\//, '')
      var route = {}
      route = {
        path: menuList[i].path.replace('/', '-'),
        component: _import(`modules/${menuList[i].path}`) || null,
        name: menuList[i].path.replace('/', '-'),
        meta: {
          menuId: menuList[i].id,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: '',
          type: menuList[i].type,
          parentId: menuList[i].parentId
        }
      }
      routes.push(route)
    } else if (menuList[i].path && /\S/.test(menuList[i].path)) { // S是匹配所有字符，s则反之   // 三级页面，添加，修改，详情
      menuList[i].path = menuList[i].path.replace(/^\//, '')
      route = {}
      route = {
        path: menuList[i].path.replace('/', '-'),
        component: _import(`modules/${menuList[i].path}`) || null,
        name: menuList[i].path.replace('/', '-'),
        meta: {
          menuId: menuList[i].id,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: '',
          type: menuList[i].type,
          parentId: menuList[i].parentId
        }
      }
      // url以http[s]://开头, 通过iframe展示
      if (isURL(menuList[i].url)) {
        route.path = `i-${menuList[i].menuId}`
        route.name = `i-${menuList[i].menuId}`
        route.meta.iframeUrl = menuList[i].url
      } else {
        try {
          route.component = _import(`modules/${menuList[i].path}`) || null
        } catch (e) {
        }
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    mainRoutes.name = 'main-dynamic'
    mainRoutes.children = routes
    router.addRoutes([
      mainRoutes,
      { path: '*', redirect: { name: '404' } }
    ])
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
    console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue')
    console.log(mainRoutes.children)
    console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')
  }
}

export default router
